<template>
    <div>
        <v-navigation-drawer v-model="drawer" fixed permanent expand-on-hover>
            <v-list>
                <v-list-item class="px-2">
                    <v-list-item-avatar>
                        <v-img src="@/assets/tp-logo.png"></v-img>
                    </v-list-item-avatar>
                </v-list-item>

                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title class="title">{{ firstName }} {{ surname }}</v-list-item-title>
                        <v-list-item-subtitle>{{ email }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <v-list dense>
                <v-list-item-group v-for="item in items" 
                                   :key="item.title"
                                   color="primary">
                    <v-list-item v-if="!item.items" :to="item.path" dense @click="item.path == '/logout' ? logout() : null">
                        <v-list-item-icon>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>

                    <v-list-group v-else no-action>
                        <template v-slot:activator>
                             <v-list-item-icon>
                                <v-icon>{{ item.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-item v-for="element in item.items"
                                     :key="element.title"
                                     :to="element.path"
                                     dense
                                     class="pl-8">
                            <v-list-item-icon>
                                <v-icon>{{ element.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ element.title }}</v-list-item-title>
                            
                        </v-list-item>
                    </v-list-group>
                </v-list-item-group>
            </v-list>

            <v-divider></v-divider>

            <v-list dense>
                <v-list-item class="state-switch-container">
                    <div class="state-switch">
                        <v-switch v-model="stateSwitch"
                                    :label="`State: ${state}`"
                                    dense
                                    @change="switchPress"
                        ></v-switch>
                    </div>
                    <div id="state-mini" class="text-center" :class="state == 'LIVE' ? 'green--text text--darken-1' : 'red--text text--darken-1'">
                        <v-btn
                            :color="state == 'LIVE' ? '#42A5F5' : '#E57373'"
                            fab
                            x-small
                            dark
                            class="elevation-0"
                        >
                            {{ state }}
                        </v-btn>
                    </div>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
    export default {
        props: {
            showPos: Boolean
        },
        data: () => ({
            items: [{ title: 'Dashboard', icon: 'mdi-home', path: '/' },
                    { title: 'Transactions', icon: 'mdi-swap-horizontal', path: '/transactions' },
                    { title: 'Transactions CS', icon: 'mdi-swap-horizontal', path: '/transactions-cs' },
                    { title: 'Chargebacks', icon: 'mdi-shield-check', path: '/chargebacks-defender' },
                    { title: 'Risk Alerts', icon: 'mdi-alert-circle', path: '/risk-alerts' },
                    { title: 'Add Client', icon: 'mdi-account-plus', path: '/add-client' },
                    { title: 'Search Clients', icon: 'mdi-account-search', path: '/search-client' },
                    { title: 'Reports', icon: 'mdi-chart-multiple', path: '/reports' },
                    { title: 'Tools', icon: 'mdi-tools', path: '', items: [
                        // { title: 'CSV Parser', icon: 'mdi-text-subject', path: '/csv-parser' },
                        { title: 'eTerminal', icon: 'mdi-tablet', path: '/eterminal' },
                        { title: 'OnBoarder', icon: 'mdi-arrow-right-bold', path: '/onboarder' },
                        { title: 'Pay By Link', icon: 'mdi-cellphone-link', path: '/pay-by-link' },
                        { title: 'Chargeback Contacts', icon: 'mdi-contacts', path: '/chargeback-contacts' }
                        ]
                    },
                    { title: 'Integrations', icon: 'mdi-file-settings-outline', path: '', items: [
                        { title: 'Add Integrations', icon: 'mdi-file-plus-outline', path: '/add-integration' },
                        { title: 'View Integrations', icon: 'mdi-file-search-outline', path: '/view-integrations' }
                        ]
                    },
                    // { title: 'Holidays', icon: 'mdi-weather-sunny', path: '', items: [
                    //     { title: 'Allowances', icon: 'mdi-note-text-outline', path: '/holiday-allowances' },
                    //     { title: 'Calendar', icon: 'mdi-calendar', path: '/holiday-calendar' },
                    //     { title: 'Requests', icon: 'mdi-clipboard-account-outline', path: '/holiday-requests' }]
                    // },
                    { title: 'Users', icon: 'mdi-account-cog', path: '', items: [
                        { title: 'Add User', icon: 'mdi-account-plus', path: '/add-user' },
                        { title: 'Edit User', icon: 'mdi-account-edit', path: '/edit-user' }]
                    },
                    // { title: 'Credentials', icon: 'mdi-key', path: '/credentials' },
                    { title: 'Logout', icon: 'mdi-logout', path: '/logout' }],
            drawer: true,
            stateSwitch: true,
            firstName: JSON.parse(localStorage.getItem('user')).first_name,
            surname: JSON.parse(localStorage.getItem('user')).surname,
            email: JSON.parse(localStorage.getItem('user')).email
        }),
        computed: {
            state() {
                return this.stateSwitch ? 'LIVE' : 'TEST';
            }
        },

        mounted: function() {
            if (this.showPos) {
                var posInsertIndex = this.items.length - 1;
                this.items.forEach((e, i) => {
                    if (e.title.includes("Transactions")) {
                        posInsertIndex = i + 1;
                    }
                });
                this.items.splice(posInsertIndex, 0, { title: 'Transactions NI POS', icon: 'mdi-swap-horizontal', path: '/transactions-ni-pos' });
            }
        },

        methods:{
            logout() {
                this.$store.dispatch('logout');
            },
            switchPress(e) {
                this.$store.dispatch('switchPress', e);
            },
        }
    }
</script>

<style>
    .state-switch-container {
        padding: 0px 2px !important;
    }

    .state-switch {
        padding-left: 15px;
    }

    .v-navigation-drawer--mini-variant .state-switch,
    .v-navigation-drawer--is-mouseover #state-mini {
        display: none;
    }

    .v-navigation-drawer--mini-variant #state-mini,
    .v-navigation-drawer--is-mouseover .state-switch {
        display: inline-block;
    }

    #state-mini {
        position: relative !important;
        overflow: visible;
        width: 100%;
    }

    #state-mini .v-btn.v-size--x-small {
        font-size: 0.5rem;
    }

    .state-switch .theme--light.v-label {
        color: rgba(0, 0, 0, 0.87);
        font-size: 0.7rem;
        font-weight: 500;
    }

    .state-switch .v-input__slot {
        width: 140px;
        height: 20px;
    }
</style>